export const device = {
  mobile: `(max-width: 768px)`,
  tablet: `(max-width: 1024px)`,
};
